import { useEffect, useState } from 'react';
/**
 * A timer that will be set to `null` after the debounce time has passed.
 *
 * @param {any} value - type declaration for the value e.g. string, number, boolean, object, array, etc..
 * @param {number} delay - the delay in milliseconds
 * @returns {any} - the value and a function to clear the timer
 *
 * usage:
 *  const debouncedVal = useDebounce<string>(value, delay);
 *
 *  useEffect(() => {
 *    // do something with debouncedVal like make an API call
 *    // this will get triggered when the debouncedVal changes
 *  }, [debouncedVal]);
 */
export var useDebounce = function (value, delay) {
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    // set the debounced value after the delay
    useEffect(function () {
        var debounce = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        // clear the timeout when the component unmounts
        return function () {
            clearTimeout(debounce);
        };
    }, [value, delay]);
    return debouncedValue;
};
